import React from "react";
import { useSelector } from "react-redux";

import { IconMainMenuMetrics } from "~/components/icon";

import { selectFeatureFlags } from "../../app/state/config/ConfigSelectors";
import { useNavigateToLink } from "../../components/react/link";
import { METRICS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemMetrics: React.FC = () => {
	const disabledNewMetrics = !useSelector(selectFeatureFlags).newMetrics;
	const link = useNavigateToLink(METRICS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (disabledNewMetrics) {
		return null;
	}

	return <MainMenuItemLayout icon={<IconMainMenuMetrics height={18} width={18} />} label="Metrics" to={link} />;
};
